import React from 'react';

const ChatInput = ({
  input,
  setInput,
  isLoading,
  textareaRef,
  handleKeyPress,
  handleFileChange,
  attachedFiles,
  removeAttachedFile,
  sendMessage,
  sendMessageWithMemory,
  sendMessageWithAgent,
  agentMode,
  memoryEnabled
}) => {
  return (
    <>
      {/* Show attached files above input container */}
      {attachedFiles.length > 0 && (
        <div style={{ padding: '8px 20px', fontSize: '12px', color: 'var(--text-secondary)', borderTop: '1px solid var(--border-color)', backgroundColor: 'var(--bg-secondary)' }}>
          {attachedFiles.map((f, idx) => (
            <span key={idx} style={{ display: 'inline-block', marginRight: '8px', padding: '4px 8px', backgroundColor: 'var(--hover-color)', borderRadius: '6px', border: '1px solid var(--border-color)' }}>
              📄 {f.name}
              <button
                onClick={() => removeAttachedFile(idx)}
                style={{ marginLeft: '6px', cursor: 'pointer', border: 'none', background: 'transparent', color: 'var(--text-secondary)', fontSize: '12px' }}
                title="Remove file"
              >✕</button>
            </span>
          ))}
        </div>
      )}

      <div className="input-container">
        <div className="input-wrapper">
              {/* Hidden file input for attachments */}
              <input
                type="file"
                id="file-input"
                style={{ display: 'none' }}
                accept=".pdf,.txt,.doc,.docx"
                onChange={handleFileChange}
              />
              <label htmlFor="file-input" className="upload-btn" title="Attach document">＋</label>
          <textarea
            ref={textareaRef}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Message ChatGPT"
            className="message-input"
            rows={1}
            disabled={isLoading}
          />
          <button 
                onClick={() => {
                  
                                        if (agentMode) {
                    sendMessageWithAgent();
                  } else if (memoryEnabled) {
                    sendMessageWithMemory();
                  } else {
                    sendMessage();
                  }
                }}
            disabled={!input.trim() || isLoading}
            className="send-button"
          >
            ➤
          </button>
        </div>
      </div>
    </>
  );
};

export default ChatInput;
